import { F5 } from "@angular/cdk/keycodes";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Version } from "../webhook-edit.component";

export interface ToolboxEvent {
    action: string;
    data?: any;
}

@Component({
    selector: 'webhook-edit-toolbar',
    templateUrl: './webhook-edit-toolbar.component.html',
    styleUrl: './webhook-edit-toolbar.component.scss',
    standalone: false,
    host:{
        '(document:keydown)': 'onKeyDown($event)'
    }
})

export class WebhookEditToolbarComponent implements OnInit {

    

    @Output() actionPerformed:EventEmitter<ToolboxEvent> = new EventEmitter<ToolboxEvent>();
    @Input()selectedVersion:Version
    debug:boolean = false;

    openVariables() {
        this.actionPerformed.emit({action: 'variables'});
    }

    deploy(){
        this.actionPerformed.emit({action: 'deploy'});
    }

    copyFlow(event){
        this.actionPerformed.emit({action: 'copy'});
    }

    logFlow(event){
        this.actionPerformed.emit({action: 'log'});
    }

    editStep(event){
        this.actionPerformed.emit({action: 'edit'});
    }

    exportData(event){
        this.actionPerformed.emit({action: 'export'});
    }

    importData(event){
        this.actionPerformed.emit({action: 'import'});
    }

    

    ngOnInit(): void {
        
    }

    dodebug(event){
        if ( this.debug ){
            this.actionPerformed.emit({action:'debugoff'})
            this.debug = false;
        }else{
            this.actionPerformed.emit({action:'debugon'})
            this.debug = true;
        }
        
    }
    
    onKeyDown(event: KeyboardEvent): void {
        if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
      return;
    }
        switch (event.keyCode) {
            case F5 : this.dodebug(null);
        }
    }


    openChange(status: boolean): void {
       
    }

    openChangeDebugMenu(event){

    }
}